<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'createTemplate',
})
</script>
<template>
    <a-modal :title="props.detailData.tagname + '-数据明细'" width="80%" :open="true" :confirmLoading="state.loading"
        :maskClosable="false" @ok="onFormSubmit" @cancel="
            () => {
                emit('cancel')
            }
        "><a-card :bordered="false">
            <div class="table-page-search-wrapper">
                <a-form>
                    <a-row :gutter="48">
                        <a-col :md="6" :sm="24">
                            <a-form-item label="公司名称" name="full_name">
                                <a-input v-model:value="queryParam.full_name" placeholder="请输入公司名称">
                                </a-input>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <a-form-item label="平台名称" name="platform_id">
                                <PlatformPick v-model:value="queryParam.platform_id"></PlatformPick>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <a-form-item label="标签颜色" name="color">
                                <a-select allow-clear mode="multiple" v-model:value="queryParam.type" placeholder="请选择">
                                    <a-select-option value="blue">正常</a-select-option>
                                    <a-select-option value="green">提示</a-select-option>
                                    <a-select-option value="orange">警告</a-select-option>
                                    <a-select-option value="red">危险</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <a-form-item label="创建时间" name="between_time">
                                <BetweenTimePick v-model:value="queryParam.between_time"></BetweenTimePick>
                            </a-form-item>
                        </a-col>
                        <a-col :md="4" :sm="24">
                            <span class="table-page-search-submitButtons">
                                <a-button type="primary" @click="loadData">查询</a-button>
                            </span>
                        </a-col>
                    </a-row>
                </a-form>
            </div>
            <a-table :columns="columns" :loading="state.loading" :data-source="dataSource" :pagination="pagination"
                @change="onChange" rowKey="id">
                <template #bodyCell="{ column, record, index, text }">
                    <template v-if="column.dataIndex === 'color'">
                        <a-tag v-if="record.color == 'blue'" color="blue">正常</a-tag>
                        <a-tag v-if="record.color == 'green'" color="green">提示</a-tag>
                        <a-tag v-if="record.color == 'orange'" color="orange">警告</a-tag>
                        <a-tag v-if="record.color == 'red'" color="red">危险</a-tag>
                    </template>
                </template>
            </a-table>
        </a-card>
    </a-modal>
</template>
<script lang="ts" setup name="createTemplate">
import { reactive, ref, onMounted, computed } from 'vue'
import { message } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import type { PaginationProps } from 'ant-design-vue'
import PlatformPick from '@/components/base/PlatformPick.vue'
import BetweenTimePick from '@/components/base/BetweenTimePick.vue'
const props = defineProps({
    detailData: {
        type: Object,
        default: () => null
    }
})
const emit = defineEmits(['cancel'])
const columns = [
    {
        title: '公司名称',
        dataIndex: 'full_name',
        width: 200
    },
    {
        title: '标签颜色',
        dataIndex: 'color',
        width: 200
    },
    {
        title: '来源',
        dataIndex: 'author',
        width: 200
    },
    {
        title: '所属平台',
        dataIndex: 'platform_name',
        width: 200
    },
    {
        title: '代理商',
        dataIndex: 'seller',
        width: 200
    },
    {
        title: '创建时间',
        dataIndex: 'created_at',
        width: 200
    }
]
interface state {
    loading: boolean
}
const state = reactive<state>({
    loading: false,
})
let queryParam = reactive<any>({
    remark: ''
})
let dataSource = ref([])
const pagination = reactive<PaginationProps>({
    pageSize: 10,
    pageSizeOptions: ['10', '50', '100', '200', '1000', '2000'],
    current: 1,
    total: undefined,
    showSizeChanger: true,
    showQuickJumper: true,
    showTotal: (total) => `总数：${total}`
})
onMounted(() => {
    loadData()
})
const loadData = () => {
    state.loading = true
    // 获取到列表数据
    let requestParam = {
        url: '/admin/v1/tagList/detail',
        method: 'post',
        data: Object.assign({ page: pagination.current, limit: pagination.pageSize, tagid: props.detailData.id }, queryParam)
    }
    baseService(requestParam).then((res) => {
        state.loading = false
        pagination.total = res.data.total_records
        dataSource.value = res.data.list.map((item) => ({ ...item, isDetail: false }))
    })
}
const onChange = (val) => {
    pagination.pageSize = val.pageSize
    pagination.current = val.current
    loadData()
}
const onFormSubmit = () => {
    emit('cancel')
}
</script>
<style lang="less" scoped></style>
